export default __webpack_public_path__ + "static/media/farm.1c451967.png";